// Packages
import { useState, useEffect, React } from "react";
import { Link, useParams } from "react-router-dom";
import PropTypes from "prop-types";
// Material Ui
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import IconButton from "@material-ui/core/IconButton";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import Toolbar from "@material-ui/core/Toolbar";
import backarrow from "../../assets/images/back-arrow.png";
// Styles
import "./schoolAdmin.css";
// Views
import SchoolAdminDashboard from './schoolAdminDashboard';
import editIcon from "../../assets/images/editIcon.png";
import schoolLogo from "../../assets/images/default_school.png";
// Services
import userService from "../../services/user.service";
// Utils
//assets
import selectClip from "../../assets/images/selectClip.png";
import annotateClip from "../../assets/images/annotateClip.png";
import mergeClip from "../../assets/images/mergeClip.png";
import pdfTronIMG from "../../assets/images/pdfTronIMG.png";


const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    typography: {
        padding: theme.spacing(2),
    },
}));

function PdfTronHome() {
    const classes = useStyles();

    return (
        <div id="highlight_S_create">
            <SchoolAdminDashboard />

           
                <div className="top-strip">
                   <div className="bgblack topMAR text-center">
                        <div className="row">
                            <div className="col-lg-12">
                                <img src={pdfTronIMG} alt="pdf"></img>
                            </div>
                        </div>
                        <div className="row mt-5 justify-center">
                           <Link to="/schoolhighlightsdata">
                           <button className="pdfDONEbtn">Done</button>
                               </Link> 
                        </div>
                   </div>

                  
                </div>
           
        </div>
    );
}

export default PdfTronHome;
